import { useVirtualizer } from '@tanstack/react-virtual';

export const useReactVirtual = ({ containerElement, items, rowHeight = 48, overscan = 10 }) => {
  const virtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => containerElement,
    estimateSize: () => rowHeight,
    overscan,
  });

  const virtualItems = virtualizer.getVirtualItems();
  const [beforeHeight, afterHeight] =
    virtualItems.length > 0
      ? [
          virtualItems[0].start - virtualizer.options.scrollMargin,
          virtualizer.getTotalSize() - virtualItems[virtualItems.length - 1].end,
        ]
      : [0, 0];

  return {
    beforeHeight,
    afterHeight,
    virtualItems,
  };
};
